import { render } from "./500.vue?vue&type=template&id=45b122bd&ts=true&lang=pug"
import script from "./500.vue?vue&type=script&lang=ts"
export * from "./500.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__